import React from 'react';
import { Route, withRouter, Switch } from 'react-router-dom';

import AppFrame from './components/AppFrame';
import PrivateRoute from './components/PrivateRoute';

import DashboardPage from './pages/Dashboard';
import UsersPage from './pages/Users';
import PhotosPage from './pages/Photos';
import SwipesPage from './pages/Swipes';
import LoginPage from './pages/Login';
import UserProfilePage from './pages/UserProfile';
import MatchPage from './pages/Match';
import MatchesPage from './pages/Matches';
import MessagesPage from './pages/Messages';
import ReportedUsers from './pages/Reports';

class App extends React.Component {
  render() {
    return (
      <React.Fragment>
        <Switch>
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/login`}
            component={LoginPage}
          />
          <AppFrame>
            <Switch>
              <PrivateRoute
                exact
                path={`${process.env.PUBLIC_URL}/`}
                component={DashboardPage}
              />
              <PrivateRoute
                exact
                path={`${process.env.PUBLIC_URL}/users`}
                component={UsersPage}
              />
              <PrivateRoute
                path={`${process.env.PUBLIC_URL}/users/:userId`}
                component={UserProfilePage}
              />
              <PrivateRoute
                exact
                path={`${process.env.PUBLIC_URL}/photos`}
                component={PhotosPage}
              />
              <PrivateRoute
                exact
                path={`${process.env.PUBLIC_URL}/swipes`}
                component={SwipesPage}
              />
              <PrivateRoute
                exact
                path={`${process.env.PUBLIC_URL}/matches`}
                component={MatchesPage}
              />
              <PrivateRoute
                path={`${process.env.PUBLIC_URL}/matches/:matchId`}
                component={MatchPage}
              />
              <PrivateRoute
                exact
                path={`${process.env.PUBLIC_URL}/messages`}
                component={MessagesPage}
              />
              <PrivateRoute
                exact
                path={`${process.env.PUBLIC_URL}/reports`}
                component={ReportedUsers}
              />
            </Switch>
          </AppFrame>
        </Switch>
      </React.Fragment>
    );
  }
}

export default withRouter(App);
